import { ISelectItem, ISelectSection } from 'common/types'

function isSection(items: ISelectItem[] | ISelectSection[]): items is ISelectSection[] {
  return (items as ISelectSection[])[0].heading !== undefined
}

export { isSection }
